import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueResource from 'vue-resource'
import i18n from './i18n'
import axios from 'axios'
import { GOGUEST_API_BASE_URL } from '@/config/environment'

axios.defaults.baseURL = GOGUEST_API_BASE_URL

Vue.config.productionTip = false

Vue.use(VueResource)

window.vm = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
